/* eslint-disable react/no-array-index-key */
import React from 'react';
import styled from 'styled-components';
import { transition } from '../../../utils/styles';

const TileListWrapper = styled.div`
  margin-top: 45px;
  margin-bottom: 0px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 900px) {
    margin-top: ${ ({ marginTopMob }) => marginTopMob || '90' }px;
  }
`;

const Tile = styled.div`
  display: flex;
  flex-direction: row;
  width: 48.7%;
  border-radius: 8px;
  box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 0px;
  background-color: white;
  text-align: left;
  ${ transition('all 0.3s ease-in-out') };

  &:nth-child(1) {
    margin-bottom: 30px;
  }
  &:nth-child(2) {
    margin-bottom: 30px;
  }

  ${ ({ hoverTransform }) =>
  hoverTransform
    ? `
    :hover {
      transform: scale(1.05);
    }
  `
    : null } @media (max-width: 900px) {
    flex-direction: column;
    width: 90.62%;
    margin: 0 auto;
    margin-bottom: 30px;
    text-align: center;
    &:nth-last-child(1) {
      margin-bottom: 0px;
    }
  }
`;

const AnkerTile = styled(Tile.withComponent('a'))`
`;

const TileLogoWrapper = styled.div`
  width: 23%;
  padding-top: 30px;
  margin-right: 0px;
  align-items: center;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

const TileLogo = styled.img`
  width: 73.19%;
  margin-left: 22.67%;
  ${ props =>
  props.shortenImg
    ? `margin-left: 14px;
      padding-left: 6.35%;`
    : '' };
  @media (max-width: 900px) {
    width: 100px;
    padding-left: 0;
    margin-left: 0;
    margin-top: 0;
  }
`;

const TileContent = styled.div`
  width: 77%;
  padding-left: 5%;
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: left;
  @media (max-width: 900px) {
    width: 100%;
    padding-top: 10px;
    padding-left: 0;
    text-align: center;
    padding-bottom: 30px;
  }
`;

const TileTitle = styled.h3`
  padding-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
  @media (max-width: 900px) {
    font-size: 15px;
  }
`;

const TileDescription = styled.div`
  font-size: 15px;
  line-height: 1.6;
  width: 85%;
  @media (max-width: 900px) {
    width: 85%;
    margin: 0 auto;
    font-size: 12px;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const LearnMore = styled.p`
  color: #00a7ff;
  display: block;
  margin-top: 10px;
`;

const LearnMoreAnker = styled(Tile.withComponent('a'))`
`;

const FunctionalityList = list =>
  list.map((item, index) => {
    const { asCardLink } = item;
    return asCardLink ? (
      <AnkerTile
        key={ `${ item.title }-key-${ index }` }
        hoverTransform
        href={ item.link }
      >
        <TileLogoWrapper>
          <TileLogo src={ item.img_src } alt={ item.title } aria-hidden='true' />
        </TileLogoWrapper>
        <TileContent>
          <TileTitle>{ item.title }</TileTitle>
          <TileDescription>
            { item.description }
            { item.link !== '' ? <LearnMore> Learn more</LearnMore> : '' }
          </TileDescription>
        </TileContent>
      </AnkerTile>
    ) : (
      <Tile key={ `${ item.title }-${ index }` }>
        <TileLogoWrapper>
          <TileLogo src={ item.img_src } alt={ item.title } aria-hidden='true' />
        </TileLogoWrapper>
        <TileContent>
          <TileTitle>{ item.title }</TileTitle>
          <TileDescription>
            { item.description }
            { item.link !== '' ? (
              <LearnMoreAnker href={ item.link }> Learn more</LearnMoreAnker>
            ) : (
              ''
            ) }
          </TileDescription>
        </TileContent>
      </Tile>
    );
  });

// eslint-disable-next-line react/prop-types
export default ({ list, marginTopMob }) => (
  <TileListWrapper marginTopMob={ marginTopMob }>
    { FunctionalityList(list) }
  </TileListWrapper>
);



// WEBPACK FOOTER //
// ./src/components/products/membership/FunctionalityTilesList.jsx